export default {
	"planMapComp": {
		"showLocal": "show landmarks",
		"multipleSelectionAddress": "please manually locate the following address list",
		"defectAddressGps": "missing coordinate address",
		"supplement": "supplement",
		"timeWindows": "time window",
		"allDay": "all day",
		"huoliang": "volume",
		"dan": "order",
		"gong": "total",
		"errMsg": "the reason for the failure of the plan is as follows",
		"start": "rise",
		"more": "many",
		"jihua": "plan",
		"daoda": "arrive",
		"likai": "leave",
		"xinxiDialog": "info window",
		"xiuzheng": "fix positioning",
		"peisong": "delivery",
		"dian": "points",
		"btnCreateRoute": "generate dispatch list",
		"aiPaixian": "smart route planning",
		"selectRouterTips": "please select a waybill",
		"rangeValueTips1": "range distance must be positive",
		"rangeValueTips2": "range distance can only be entered in numbers",
		"noTransports": "No trial calculation of the line",
		"none": "none",
    	"back": "back",
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/planMapComp/planMapComp.js